import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../../index.css";
import { HrApi } from "../../../initialpage/hooks/HrApi";

const AdminDashboard = () => {
  const [totalEmployee, setTotalEmployee] = useState(0);
  const [totalLoan, setTotalLoan] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [totalCurrentEmployee, setTotalCurrentEmployee] = useState(0);
  const [totalCurrentEmployeeHealth, setTotalCurrentEmployeeHealth] = useState(0);
  const [totalMissingLpr, setTotalMissingLpr] = useState(0);
  const [totalDepartment, setTotalDepartment] = useState([]);
  const [totalDesignation, setTotalDesignation] = useState([]);
  const [totalUser, setTotalUser] = useState([]);
  const [totalEmpDisciplinesArray, setTotalEmpDisciplinesArray] = useState([]);

  useEffect(() => {
    const getUsers = () => {
      setIsLoading(true);
      fetch(`${HrApi}/hr/emp/getAllEmp`)
        .then((res) => {
          if (res.status >= 400) {
            throw new Error("Server responds with error!");
          }
          return res.json();
        })
        .then(
          (users) => {
            const empGetData = users?.data;
            const filterData = empGetData.filter((item) => item.ACTIVE === 1);
            setTotalEmployee(filterData.length);
            setIsLoading(false);
          },
          (err) => {
            const mute = err;
            setHasError(true);
            setIsLoading(true);
          }
        );
    };
    getUsers();
  }, []);

  useEffect(() => {
    const getUsers = () => {
      setIsLoading(true);
      fetch(`${HrApi}/hr/setting/get/department`)
        .then((res) => {
          if (res.status >= 400) {
            throw new Error("Server responds with error!");
          }
          return res.json();
        })
        .then(
          (users) => {
            setTotalDepartment(users.items.length);
            setIsLoading(false);
          },
          (err) => {
            const mute = err;
            setHasError(true);
            setIsLoading(true);
          }
        );
    };
    getUsers();
  }, []);

  useEffect(() => {
    const getUsers = () => {
      setIsLoading(true);
      fetch(`${HrApi}/hr/setting/get/designation`)
        .then((res) => {
          if (res.status >= 400) {
            throw new Error("Server responds with error!");
          }
          return res.json();
        })
        .then(
          (users) => {
            setTotalDesignation(users.items.length);
            setIsLoading(false);
          },
          (err) => {
            const mute = err;
            setHasError(true);
            setIsLoading(true);
          }
        );
    };
    getUsers();
  }, []);

  useEffect(() => {
    const getUsers = () => {
      setIsLoading(true);
      fetch(`${HrApi}/hr/emp/getUser`)
        .then((res) => {
          if (res.status >= 400) {
            throw new Error("Server responds with error!");
          }
          return res.json();
        })
        .then(
          (users) => {
            setTotalUser(users.items.length);
            setIsLoading(false);
          },
          (err) => {
            const mute = err;
            setHasError(true);
            setIsLoading(true);
          }
        );
    };
    getUsers();
  }, []);

  return (
    <>
      <div className="page-wrapper">
        <Helmet>
          <title>Dashboard - HR</title>
          <meta name="description" content="Dashboard" />
        </Helmet>

        {/* Page Content */}
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Welcome Admin!</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item active">Dashboard</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          <div className="row">
            {/* Employee Card */}
            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div className="card dash-widget" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                <div className="card-body">
                  <span className="dash-widget-icon" style={{ color: 'white' }}>
                    <i className="fa fa-users" />
                  </span>
                  <div className="dash-widget-info">
                    <h3 style={{ color: 'white' }}>{totalEmployee}</h3>
                    <span style={{ color: 'rgba(255,255,255,0.8)' }}>Employees</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Department Card */}
            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div className="card dash-widget" style={{ background: 'linear-gradient(135deg, #2b5876 0%, #4e4376 100%)' }}>
                <div className="card-body">
                  <span className="dash-widget-icon" style={{ color: 'white' }}>
                    <i className="fa fa-building" />
                  </span>
                  <div className="dash-widget-info">
                    <h3 style={{ color: 'white' }}>{totalDepartment}</h3>
                    <span style={{ color: 'rgba(255,255,255,0.8)' }}>Total Department</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Designation Card */}
            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div className="card dash-widget" style={{ background: 'linear-gradient(135deg,rgb(171, 0, 29) 0%,rgb(232, 11, 48) 100%)' }}>
                <div className="card-body">
                  <span className="dash-widget-icon" style={{ color: 'white' }}>
                    <i className="fa fa-id-card"></i>
                  </span>
                  <div className="dash-widget-info">
                    <h3 style={{ color: 'white' }}>{totalDesignation}</h3>
                    <span style={{ color: 'rgba(255,255,255,0.8)' }}>Total Designation</span>
                  </div>
                </div>
              </div>
            </div>

            {/* User Card */}
            <div className="col-md-6 col-sm-6 col-lg-6 col-xl-3">
              <div className="card dash-widget" style={{ background: 'linear-gradient(135deg,rgb(0, 120, 82) 0%, #185a9d 100%)' }}>
                <div className="card-body">
                  <span className="dash-widget-icon" style={{ color: 'white' }}>
                    <i className="fa fa-user-circle" />
                  </span>
                  <div className="dash-widget-info">
                    <h3 style={{ color: 'white' }}>{totalUser}</h3>
                    <span style={{ color: 'rgba(255,255,255,0.8)' }}>Total User</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;